/**
 * 呼叫中心
 */
import { ContentTypeEnum } from '@/enums/axios'
import request from '@/utils/axios'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}
// 呼叫中心-录音下载
export const getCdrMediaDownloads = '/call/callDetailRecord/cdrMediaDownloadNew'

// 呼叫中心-录音播放
// export const getCallRecordingPlayback = '/call/callDetailRecord/callRecordingPlayback'
export const getCallRecordingPlayback = (data: any) =>
  request.get('/call/callDetailRecord/callRecordingPlayback', data)

// 获取员工默认呼叫方式
export const queryOrUpdateCallType = (data?: any) =>
  request.post('/call/callCenterStaff/queryOrUpdateCallType', data, jsonHeaderConfig)
// 获取当前用户呼叫中心相关配置信息
export const queryCurrentCallCenterConf = (data?: any) =>
  request.post('/call/callCenter/queryCurrentCallCenterConf', data)
// 呼叫中心-拨叫电话预检接口
export const callCenterCheck = (data: any) =>
  request.post('/call/callCenter/pre/outbound/check', data, jsonHeaderConfig)
// 呼叫中心-电话关联的客户信息接口
export const callCenterLinkInfo = (data: any) =>
  request.post('/call/callCenter/inbound/queryLinkInfo', data, jsonHeaderConfig)
// 获取SIP呼叫默认线路
export const getDefaultSipLine = () => request.post('/call/callCenter/v2/getLineSelector', null)
// 获取是否唤起APP
export const queryPcEvokeMobile = () =>
  request.post('/call/callCenterStaff/queryPcEvokeMobile', null)
// 电话条-设置pc唤起手机开关接口

export const setPcEvokeMobile = (data: any) =>
  request.post('/call/callCenterStaff/setPcEvokeMobile', data, jsonHeaderConfig)

// 设置sip呼叫默认线路
export const setDefaultSipLine = (data: any) =>
  request.post('/call/callCenter/setDefaultSipLine', data, jsonHeaderConfig)
// 查询明文手机号码
export const queryPlaintextPhoneNum = (data: any) =>
  request.post('/call/callCenter/queryPlaintextPhoneNum', data)
// 查询手机号码和联系人名称的明文信息
export const queryPlaintextDataApi = (data: any) =>
  request.post('/call/callCenter/queryPlaintextData', data)
// 多卡话机拨打生成callId
export const generateCallId = (data: any) =>
  request.post('/call/callCenter/generateCallId/' + data, null)
// 获取客户跳转标识
export const getCustomerRedirectFlag = (data: any) =>
  request.post('/call/callCenter/getCustomerRedirectFlag', data, jsonHeaderConfig)
// 获取用户默认呼叫方式配置信息
export const setDefaultCallTypeFirst = () =>
  request.post('/call/callCenterStaff/setDefaultCallTypeFirst', null)
// 释放通话锁
export const releaseGlobalDialLock = () =>
  request.post('/call/callCenter/releaseGlobalDialLock', null)
// 自研线路挂断
export const sipHangUp = (data: any) =>
  request.post('/call/callCenter/sip/upAndDownCall', data, jsonHeaderConfig)
// 自研线路定时任务
export const callEventLoop = (data: any) =>
  request.post('/call/callDetailRecord/callEventLoop', data, jsonHeaderConfig)
// sip快速拨号关联通话记录接口
export const sipQuickDialRelateCdr = (data: any) =>
  request.post('/call/callCenter/sipQuickDialRelateCdr', data, jsonHeaderConfig)
// 设置多卡话机路径时调用
export const cacheUserIdAndCustId = (data: any) =>
  request.post('/call/callDetailRecord/cacheUserIdAndCustId', data, jsonHeaderConfig)
// 呼叫中心-挂断后处理接口
export const callCenterHangUp = (data: any) =>
  request.post('/call/callCenter/after/hangUp', data, jsonHeaderConfig)
// pc唤起手机拨叫接口
export const pcEvokeCellPhoneDial = (data: any) =>
  request.post('/call/callCenter/v2PcEvokeCellPhoneDial', data, jsonHeaderConfig)
// 呼叫中心-客户详情关联通话记录
export const linkedCdrList = (data?: Recordable, headers: any = undefined) => {
  return request.post(
    '/call/callDetailRecord/linkedCdrList',
    data,
    headers ? { headers: { ...jsonHeaderConfig, ...headers } } : jsonHeaderConfig
  )
}

// 空号校验
export const checkNumberApi = (data: any) =>
  request.post('/call/callCenter/checkNumber', data, jsonHeaderConfig)

export const getWorkDevice = (data: any) =>
  request.get('/call/zzy/work/machine/getWorkDevice', data)
